import React, { useContext } from 'react';

import { CompanyContext } from 'common/containers/CompanyContainer';
import { ShowIntercomContext } from 'common/containers/IntercomContainer';
import { RouterContext } from 'common/containers/RouterContainer';
import AdminQueueAlert, {
  AlertTypes,
} from 'common/subdomain/admin/AdminQueue/AdminQueueAlerts/AdminQueueAlert';
import ButtonV2 from 'common/ui/ButtonV2';
import { P } from 'common/ui/Text';
import isOnNewPricingPlan from 'common/util/isOnNewPricingPlan';

const AdminQueueCreditLimit = () => {
  const router = useContext(RouterContext);
  const showIntercom = useContext(ShowIntercomContext);
  const company = useContext(CompanyContext);

  if (isOnNewPricingPlan(company.billingData?.plan?.planID)) {
    return (
      <AdminQueueAlert
        type={AlertTypes.warning}
        text={
          <P>
            You've processed a lot of feedback with Autopilot! We're doing a quick review to ensure
            proper use before approving continued access. Contact us if you have any questions.
          </P>
        }
        actions={
          <ButtonV2 onClick={() => showIntercom()} size="medium">
            Contact us
          </ButtonV2>
        }
      />
    );
  }

  return (
    <AdminQueueAlert
      type={AlertTypes.error}
      text={
        <P>
          Your Autopilot credits have run out, and feedback processing has stopped. To continue
          receiving insights and feedback, please purchase more&nbsp;credits.
        </P>
      }
      actions={
        <ButtonV2 onClick={() => router.push('/admin/settings/billing/autopilot')} size="medium">
          Purchase credits
        </ButtonV2>
      }
    />
  );
};

export default AdminQueueCreditLimit;
